import { matchRoutes } from 'react-router-dom'
import type { RouteObject } from 'react-router'
import type { AppRouteHandle, DocumentTitleTokenRef } from '@/types/route-handle'

export function getDocumentTitleRefForPathname(
  pathname: string,
  routeTree: RouteObject[]
): DocumentTitleTokenRef | undefined {
  const matches = matchRoutes(routeTree as RouteObject[], pathname)
  if (!matches?.length) {
    return undefined
  }
  const matchWithTitle = [...matches]
    .reverse()
    .find((m) => (m.route.handle as AppRouteHandle | undefined)?.documentTitle)

  return (matchWithTitle?.route.handle as AppRouteHandle | undefined)
    ?.documentTitle
}
